import { jsx as o } from "react/jsx-runtime";
import { HTMLRenderer as n } from "../../../../components/HTMLRenderer/index.js";
import { ALLOWED_COMMENT_TAGS as i } from "../../../../services/html/index.js";
import { Text as d, Paragraph as a, UnorderedList as p, OrderedList as c } from "./style.js";
import { CommentImage as l } from "../CommentImage/index.js";
const s = (r) => ({
  p: a,
  ul: p,
  ol: c,
  img: ({ src: e }) => /* @__PURE__ */ o(l, { src: e, alt: "", onLoad: r })
}), M = ({
  children: r,
  className: e,
  onImageLoad: t,
  clickoutFunction: m
}) => /* @__PURE__ */ o(d, { className: e, children: /* @__PURE__ */ o(
  n,
  {
    override: s(t),
    allowedTags: i,
    clickoutLinkFactory: m,
    children: r
  }
) });
export {
  M as CommentContentRenderer
};
